const BASE_URL = process.env.NODE_ENV === "production" ? "https://api.atripa.ir" : "";

export const BASE_URL_IR = process.env.NODE_ENV === "production" ? "https://api.atripa.ir" : "";

export default BASE_URL;
